import { UAParser } from "ua-parser-js";

const uap = new UAParser();

export function isLegacyMicrosoftEdge(): boolean {
  return uap.getEngine().name === "EdgeHTML";
}

export function isiOSDevice(): boolean {
  return uap.getOS().name === "iOS";
}

export function isAndroidDevice(): boolean {
  return uap.getOS().name === "Android";
}

export function isMobileDevice(): boolean {
  return uap.getDevice().type === "mobile" || isiOSDevice() || isAndroidDevice();
}

export function isSafari(): boolean {
  return uap.getBrowser().name === "Safari" || uap.getBrowser().name === "Mobile Safari";
}

export function convertToNotarizeScheme(url: string): string {
  return url.replace(/^http[s]?/, "notarize");
}
